// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCategoriesStyles } from "@conklin/App/Widgets/ProductCategories/ProductCategories";
import { StyledTypography } from "@conklin/MobiusOverrides/Link/Link";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, ellipsis, linkArrowStyle, xScreen } from "@conklin/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productCategoriesStyles.wrapper = {
    css: css`
        display: grid;
        gap: 48px 22px;
        grid-template-columns: repeat(4, minmax(0, 1fr));

        ${xScreen("lte", "md")} {
            gap: 24px 20px;
        }

        ${xScreen("lte", "sm")} {
            grid-template-columns: repeat(2, minmax(0, 1fr));
            gap: 24px 16px;
        }
        ${xScreen("lte", "xs")} {
           grid-template-columns: minmax(0, 1fr);
        }
    `,
};

productCategoriesStyles.cardContainer = {
    css: css`
        display: flex;
        align-items: flex-start;
        gap: 12px 16px;
`,
};

productCategoriesStyles.cardContent = {
    css: css`
        ${xScreen("lte", "xs")} {
            display: flex;
            flex-direction: column;
            width: 100%;
        }
    `,
};
productCategoriesStyles.cardImageLink = {
    css: css`
        ${StyledTypography} {
            line-height: 1;
        }
    `,
};

productCategoriesStyles.cardTitle = {
    mergeCss: true,
    typographyProps: {
        css: css`
            font-size: 18px;
            line-height: 22px;
            margin-bottom: 12px;
            font-weight: ${fontConfig.weight.bold};
            ${ellipsis(2)}
        `,
    },
    color: "text",
    css: css`
        width: 100%;
    `,
};

productCategoriesStyles.cardSubLinksList = {
    css: css`
        margin: 0 0 16px 0;

        li::marker {
            color: ${color("primary")};
        }
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

productCategoriesStyles.cardSubLink = {
    typographyProps: {
        size: 14,
        lineHeight: "17px",
        weight: fontConfig.weight.regular,
        css: css`
            text-decoration: underline;
        `,
    },
    css: css`
        && {
            ${StyledTypography}, &:visited ${StyledTypography} {
                color: ${color("text.main")};
            }
            &:hover {
                ${StyledTypography} {
                    color: ${color("common.ui10")};
                }
            }
        }
    `,
};

productCategoriesStyles.viewAllLink = linkArrowStyle("small");
productCategoriesStyles.title = {
    variant: "h2",
};
